<template>
  <v-app white>

    <!-- <v-navigation-drawer app clipped fixed v-model="drawer" width="200px;" class="menu-principal">
      <v-list dense>
        <v-card tile v-for="(item, i) in menu" :key="i" :to="item.path" :class="item.path === $route.path ? 'highlighted' : ''">
            <v-icon>{{ item.icon }}</v-icon>
            <p>{{ item.title }}</p>
        </v-card>
        <v-card tile @click="logout()">
            <v-icon>logout</v-icon>
            <p>Logout</p>
        </v-card>
      </v-list>
    </v-navigation-drawer> -->

    <header class="header-app">
      <div class="container-fluid">
        <v-row>
          <v-col cols="12" sm="12" class="text-center">
            <router-link :to="{name:'home'}">
              <img class="logo mt-2" :src="require('@/assets/ead-viamaker.svg')" alt="Logo EAD Viamaker"/>
            </router-link>
          </v-col>
        </v-row>
      </div>
    </header>

    <v-navigation-drawer
      permanent
      expand-on-hover
      app
      dark
      color="#4B657C"
      class="menu-principal"
    >
      <v-list nav dense>
        <v-list-item class="avatar-custom" :to="{name: 'user-register'}">
          <v-list-item-avatar>
            <v-img v-if="userThumb" :src="userThumb"></v-img>
            <v-img v-else src="@/assets/user-bg-default.jpg"></v-img>
          </v-list-item-avatar>
          <p>{{ userName }}</p>
        </v-list-item>

        <v-list-item link v-for="(item, i) in menu" :key="i" :to="{ name: item.name }"
                     :class="item.name === $route.name ? 'active-custom' : ''">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item link @click="logout()">
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            Logout
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>


    <!-- <v-toolbar fixed height="110px;">
        <v-icon @click.stop="drawer = !drawer">menu</v-icon>
        <img src="../assets/mundi-play-logo.png" alt="Mundi Play Logo" @click="goToHome" class="logo-topo"/>
    </v-toolbar> -->

    <v-main app class="layout-app">
      <router-view/>
    </v-main>

    <v-footer class="footer-app">
      <div class="line-footer">
        <div class="container-fluid">
          <v-row>
            <v-col cols="12" md="6" class="logo-footer">
              <router-link :to="{name:'home'}">
                <img src="@/assets/ead-viamaker-white.svg" alt="Logo EAD Viamaker"/>
              </router-link>
            </v-col>
            <v-col cols="12" md="6" class="text-footer">
              <p><b>EAD Viamaker</b><br/> © {{ new Date().getFullYear() }} Copyright</p>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-footer>

  </v-app>
</template>

<script>
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { mapActions, mapGetters } from 'vuex'
import EventBus from '@/eventBus'

library.add(faFacebookF, faInstagram, faLinkedinIn)

export default {
  name: 'LayoutUser',
  data: () => ({
    drawer: true
  }),
  computed: {
    ...mapGetters(['permissions', 'getUser']),
    menu: function () {
      const items = []

      for (const route of this.$router.options.routes) {

        if (route.name === 'user') {
          for (const child of route.children) {
            if (child.meta && child.meta.permissions) {
              let has = child.meta.permissions.find(permission => {
                return this.permissions[permission] === true
              })

              if (has && child.menu) {
                items.push(child)
              }
            }
          }
        }
      }
      return items
    },
    userThumb: function () {
      return this.getUser.thumb
    },
    userName: function () {
      return this.getUser.name
    }
  },
  created () {
    EventBus.$on('DRAWER_MENU', (value) => {
      this.updateDrawer(value)
    })

    if (window.innerWidth < 1264) {
      this.drawer = false
    }
  },

  methods: {
    ...mapActions(['clearState']),
    logout () {
      this.clearState()

      this.$router.go(0)
    },
    updateDrawer (v) {
      setTimeout(() => {
        this.drawer = v
      }, 100)
    }
  }
}
</script>
